import { getGameResults } from "./GetGameResults";
import { hasSetScores } from "./hasSetScores";

// Returns the key suffix used to store a team's poule membership
// (i.e. team["poule<key>"] / team["numInPoule<key>"]).
// - For bracket poules, the key depends on the round/bracket structure.
// - For non-bracket destinations we fall back to `sourceFase`, which matches
//   how `moveTeamToPouleSpot` writes teams (it always uses the source poule's
//   `fase` argument when the destination is not a bracket).
export const getBracketPouleKeyName = (poule, bracketsByKey, sourceFase) => {
  if (!poule) {
    return sourceFase;
  }
  if (!poule.bracket) {
    return sourceFase;
  }
  const bracket = (bracketsByKey || {})[poule.bracket] || {};
  return poule.bracketRound === bracket.size && !bracket.subBracketTo
    ? poule.fase
    : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
};

export const findTeamInPouleSpot = (
  teams,
  pouleId,
  numInPoule,
  pouleKeyName
) => {
  return (teams || []).find(
    (team) =>
      team["poule" + pouleKeyName] === pouleId &&
      Number(team["numInPoule" + pouleKeyName]) === Number(numInPoule)
  );
};

const markedWinnerOrNull = (markedWinner) => {
  if (
    markedWinner === null ||
    markedWinner === undefined ||
    markedWinner === ""
  ) {
    return null;
  }
  const value = Number(markedWinner);
  return Number.isNaN(value) ? null : value;
};

const loserForWinner = (winner, team1, team2) => {
  if (winner === team1) {
    return team2;
  }
  if (winner === team2) {
    return team1;
  }
  return null;
};

export const getBracketWinnerAndLoser = ({
  team1,
  team2,
  useSets,
  gameResults,
  score1,
  score2,
  markedWinner,
  otherMatch,
  scoring,
}) => {
  let winner = team1;

  if (useSets) {
    if (gameResults.result1 < gameResults.result2) {
      winner = team2;
    } else if (gameResults.result1 === gameResults.result2) {
      winner = markedWinnerOrNull(markedWinner);
    }
  } else if (Number(score1) < Number(score2)) {
    winner = team2;
  } else if (Number(score1) > Number(score2)) {
    winner = team1;
  } else {
    winner = markedWinnerOrNull(markedWinner);
  }

  if (otherMatch) {
    const otherGameResults = useSets
      ? getGameResults(scoring, otherMatch.sets || {})
      : null;
    const otherFinished = useSets
      ? !!(otherGameResults && otherGameResults.finished)
      : hasSetScores(otherMatch.score1, otherMatch.score2);

    if (!otherFinished) {
      return { winner: null, loser: null };
    }

    if (useSets) {
      const otherR1 =
        otherMatch.team1 === team1
          ? otherGameResults.result1
          : otherGameResults.result2;
      const otherR2 =
        otherMatch.team2 === team2
          ? otherGameResults.result2
          : otherGameResults.result1;
      const total1 = gameResults.result1 + otherR1;
      const total2 = gameResults.result2 + otherR2;
      winner = team1;
      if (total1 < total2) {
        winner = team2;
      } else if (total1 === total2) {
        winner = markedWinnerOrNull(markedWinner);
        if (winner === null && otherMatch.winner != null) {
          winner = Number(otherMatch.winner);
        }
      }
    } else {
      const otherScore1 = Number(
        otherMatch.team1 === team1 ? otherMatch.score1 : otherMatch.score2
      );
      const otherScore2 = Number(
        otherMatch.team2 === team2 ? otherMatch.score2 : otherMatch.score1
      );
      const totalScores1 = Number(score1) + otherScore1;
      const totalScores2 = Number(score2) + otherScore2;
      winner = team1;
      if (totalScores1 < totalScores2) {
        winner = team2;
      } else if (totalScores1 === totalScores2) {
        winner = markedWinnerOrNull(markedWinner);
        if (winner === null && otherMatch.winner != null) {
          winner = Number(otherMatch.winner);
        }
      }
    }
  }

  if (winner === null) {
    return { winner: null, loser: null };
  }

  return {
    winner,
    loser: loserForWinner(winner, team1, team2),
  };
};
